export default __webpack_public_path__ + "static/media/loader-version-2.8a27cd89.svg";